import { editarCuadrosTurnos } from "../../modules/NominaCuadrosTurnos/services/nomina-cuadro-turnos";
import { toast } from "../helpers/message-helper";
import useOpciones from "./use-opciones";

const TURNOS_SELECCIONADOS = "turnosSeleccionados";

const useTurno = () => {
    const { ocultarCuadroOpciones, resetOpciones } = useOpciones("turnos");

    const vaciarTurnosSeleccionados = () => {
        window.localStorage.setItem(TURNOS_SELECCIONADOS, JSON.stringify([]));
    };

    const obtenerTurnosSeleccionados = () => {
        try {
            let turnosSeleccionados =
                window.localStorage.getItem(TURNOS_SELECCIONADOS);
            return JSON.parse(turnosSeleccionados) ?? [];
        } catch (e) {
            return [];
        }
    };

    const agregarTurno = (turno) => {
        const turnos = obtenerTurnosSeleccionados();
        if (estaTurnoSeleccionado(turno.idcuadroturno)) return;

        turnos.push(turno);
        window.localStorage.setItem(
            TURNOS_SELECCIONADOS,
            JSON.stringify([...turnos])
        );
    };

    const removerCeldasActivas = () => {
        const celdasActivas = document.querySelectorAll(
            ".celda-cuadro-turno.activo"
        );
        celdasActivas.forEach((celda) => celda.classList.remove("activo"));
    };

    const estaTurnoSeleccionado = (idCuadroTurno) => {
        const turnos = obtenerTurnosSeleccionados();
        const turnoEncontrado = turnos.find(
            (turno) => turno.idcuadroturno == idCuadroTurno
        );

        return turnoEncontrado != null;
    };

    const actualizarTurnos = async (nuevoTurno, turnosACambiar) => {
        vaciarTurnosSeleccionados();
        ocultarCuadroOpciones();
        resetOpciones();

        removerCeldasActivas();
        turnosACambiar.forEach((turnoAnterior) => {
            actualizarCeldasTurnos(nuevoTurno, turnoAnterior);
        });

        const idsTurnosSeleccionados = turnosACambiar.map((turno) =>
            parseInt(turno.idcuadroturno)
        );

        const resp = await editarCuadrosTurnos(
            nuevoTurno.turno_sede,
            idsTurnosSeleccionados
        );

        if (!resp.status) return toast.error(resp.message);
    };

    const actualizarSumatoriaDeTurnosSubArea = (turnoNuevo, turnoAnterior) => {
        const sumatoriaTurnoNuevo = document.getElementById(
            `cantidad-turnos-${turnoNuevo.sigla}-${turnoAnterior.subarea}-${turnoAnterior.fecha}`
        );

        const sumatoriaTurnoAnterior = document.getElementById(
            `cantidad-turnos-${turnoAnterior.sigla}-${turnoAnterior.subarea}-${turnoAnterior.fecha}`
        );

        if (sumatoriaTurnoNuevo) {
            const cantidad = parseInt(sumatoriaTurnoNuevo.textContent);

            if (turnoAnterior.sigla != turnoNuevo.sigla) {
                sumatoriaTurnoNuevo.textContent = cantidad + 1;
            }
        }

        if (sumatoriaTurnoAnterior) {
            const cantidad = parseInt(sumatoriaTurnoAnterior.textContent);

            if (turnoAnterior.sigla != turnoNuevo.sigla) {
                sumatoriaTurnoAnterior.textContent = cantidad - 1;
            }
        }
    };

    /**
     * Recibe el id de la celda que se quiere modificar, restando la cantidad de horas del turno anterior
     * y sumando la cantidad de horas del turno nuevo.
     *
     * Se usa para actualizar el valor de las celdas "Total Horas Semana" y "Total Horas Acumuladas"
     * @param {string} celdaId
     * @param {number} horasTurnoAnterior
     * @param {number} horasTurnoNuevo
     */
    const modificarValorTotalHoras = (
        celdaId,
        horasTurnoAnterior,
        horasTurnoNuevo
    ) => {
        const celda = document.getElementById(celdaId);
        let valorTotalHoras = parseFloat(celda.textContent);

        valorTotalHoras -= horasTurnoAnterior;
        valorTotalHoras += horasTurnoNuevo;
        celda.textContent = valorTotalHoras;
    };

    const actualizarCeldasTurnos = (nuevoTurno, turnoAnterior) => {
        // Actualizar valor de la siguiente celda "Total Horas Semana"
        modificarValorTotalHoras(
            turnoAnterior.totalhorassemanaid,
            turnoAnterior.libre == 1 ? 0 : parseInt(turnoAnterior.horas),
            nuevoTurno.libre == 1 ? 0 : parseInt(nuevoTurno.horas_turno)
        );

        // Actualizar valor de celda "Total Horas Acumuladas"
        modificarValorTotalHoras(
            turnoAnterior.totalhorasacumuladasid,
            turnoAnterior.libre == 1 ? 0 : parseInt(turnoAnterior.horas),
            nuevoTurno.libre == 1 ? 0 : parseInt(nuevoTurno.horas_turno)
        );

        const celdaTurno = document.getElementById(turnoAnterior.idceldaturno);
        celdaTurno.dataset.sigla = nuevoTurno.sigla;
        celdaTurno.dataset.horas = parseInt(nuevoTurno.horas_turno);
        celdaTurno.dataset.turnosede = nuevoTurno.turno_sede;
        celdaTurno.dataset.libre = nuevoTurno.libre;
        celdaTurno.dataset.color = nuevoTurno.color;
        celdaTurno.style.backgroundColor = nuevoTurno.color;

        const spanSigla = document.querySelector(
            `#${turnoAnterior.idceldaturno} .sigla-turno`
        );
        spanSigla.textContent = nuevoTurno.sigla;
        actualizarSumatoriaDeTurnosSubArea(nuevoTurno, turnoAnterior);
    };

    return {
        obtenerTurnosSeleccionados,
        vaciarTurnosSeleccionados,
        agregarTurno,
        estaTurnoSeleccionado,
        removerCeldasActivas,
        actualizarTurnos,
        actualizarCeldasTurnos,
    };
};

export default useTurno;
